(function() {
    'use strict';
    var RejectCreditDetailsCtrl = function($scope, $compile,ajaxCall, xmsNotificationFactory) {
        console.log("Inside RequestUpdateCreditDetailsCtrl");
        $scope.ngModel = {};
        console.log("$scope.creditDetailsModel"+$scope.ngModel)

        $scope.fnRejectCreditDetails = function($event) {

            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/creditDetails/rejectCreditDetails?";
            var data    = $scope.ngModel;

            console.log("data .."+data)
 
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    /*console.log("successul ");
                    console.log("result.data"+result);
                    for(var key in result) {
                        console.log("key::"+key)
                        var obj = result[key];
                        console.log("object::"+obj)
                    }*/
                    var alertMessage = "Credit Details Update Request Rejected.";
                    xmsNotificationFactory.addObj({id: "rejectCreditDetails", type: "success", bodyHtml: alertMessage, timeout:5});
                     $scope.ok();
                },
                function(result) {
                    console.log("failure ");
                    var alertMessage = "Error occurred. Please try again later.";
                    xmsNotificationFactory.addObj({id: "rejectCreditDetails", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $scope.ok();

                }
            );
            $event.preventDefault();
        }

    }
    RejectCreditDetailsCtrl.$inject = ['$scope', '$compile', 'ajaxCall', 'xmsNotificationFactory'];
    angular.module('app').controller('RejectCreditDetailsCtrl', RejectCreditDetailsCtrl);
}());
